var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"text-container"},[_c('ol',[_c('li',[_vm._v(_vm._s(_vm.$t('compare_loans_text_1')))]),_c('li',[_vm._v(_vm._s(_vm.$t('compare_loans_text_2')))]),_c('li',[_vm._v(_vm._s(_vm.$t('compare_loans_text_3')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }